export const ADD_TO_CLOSED = "ADD_TO_CLOSED";

export const addToClosed = (key) => ({
  type: ADD_TO_CLOSED,
  payload: key,
});
